<script lang="ts" setup>
const store = useStore()
const { modalInatividade } = storeToRefs(store)

const fazerLoginNovamente = async () => {
  const config = useRuntimeConfig()

  try {
    // Tenta chamar o endpoint de logout no backend
    await useApiStore().request('/autenticacao/sair', {
      method: 'POST',
    })
  } catch (error) {
    console.error('Erro ao fazer logout no backend:', error)
  }

  // Reset dos stores seguindo o padrão do projeto
  store.$reset()
  useOrcamentoStore().$reset()
  useLivroDiarioAuxiliarStore().$reset()
  useAutenticacaoStore().$reset()
  useLarkStore().$reset()

  // Redireciona para a página de login
  window.location.href = config.public.loginUrl
}
</script>

<template>
  <CModal
    :visible="modalInatividade.exibir"
    backdrop="static"
    keyboard="false"
    scrollable
    size="sm"
  >
    <CModalHeader class="bg-warning text-dark" :close-button="false">
      <CModalTitle>
        Sessão Expirada
      </CModalTitle>
    </CModalHeader>
    <CModalBody class="text-center">
      <div class="mb-3">
        <CIcon icon="cil-user-unfollow" size="3xl" class="text-warning mb-3" />
      </div>
      <h5 class="mb-3">
        Tempo de inatividade excedido
      </h5>
      <p class="text-muted">
        Você ficou ausente por mais de 30 minutos. Por questões de segurança,
        sua sessão foi encerrada e você precisa fazer login novamente.
      </p>
    </CModalBody>
    <CModalFooter class="justify-content-center">
      <CButton
        color="primary"
        @click="fazerLoginNovamente"
      >
        <CIcon icon="cil-account-logout" class="me-2" />
        Fazer Login Novamente
      </CButton>
    </CModalFooter>
  </CModal>
</template>
